<ng-container *ngIf="variableParamsChanged$ | async"></ng-container>
<div class="w-full flex flex-row space-x-3 items-start flex-1" cslEnterLikeTab>
  <div class="w-full flex flex-col items-start flex-1" cslEnterLikeTab>
    <div class="flex flex-row space-x-3 items-start">
      <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }">
        <mat-label>X</mat-label>
        <input
          data-testId="xInput"
          type="number"
          [ngModel]="_X"
          #X="ngModel"
          (ngModelChange)="X.invalid ? null : paramChanged(xChange, 'X', $event)"
          matInput
          required
          [range]="[xMin, xMax]"
          number
          (click)="$any($event.target).select()"
          [disabled]="!editable" />
        <div i18n matSuffix>мм</div>
        <mat-error *ngIf="X.invalid"> ≥{{ xMin }}, ≤{{ xMax }} </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }">
        <mat-label>Y</mat-label>
        <input
          data-testId="yInput"
          type="number"
          [ngModel]="_Y"
          #Y="ngModel"
          (ngModelChange)="Y.invalid ? null : paramChanged(yChange, 'Y', $event)"
          matInput
          required
          [range]="[yMin, yMax]"
          number
          (click)="$any($event.target).select()"
          [disabled]="!editable" />
        <div i18n matSuffix>мм</div>
        <mat-error *ngIf="Y.invalid"> ≥{{ yMin }}, ≤{{ yMax }} </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }">
        <mat-label>R</mat-label>
        <input
          data-testId="rInput"
          type="number"
          [ngModel]="_R"
          #R="ngModel"
          (ngModelChange)="R.invalid ? null : paramChanged(rChange, 'R', $event)"
          matInput
          required
          [range]="[rMin, rMax]"
          number
          (click)="$any($event.target).select()"
          [disabled]="!editable" />
        <div i18n matSuffix>мм</div>
        <mat-error *ngIf="R.invalid"> ≥{{ rMin }}, ≤{{ rMax }} </mat-error>
      </mat-form-field>
    </div>
  </div>
</div>
